import {FormControl, ValidationErrors} from '@angular/forms';
import {timer} from 'rxjs/observable/timer';
import {map, switchMap} from 'rxjs/operators';
import {Success as SuccessResponse} from '../../Backend/Rest/Response/Success';
import {Connector as RestConnector} from '../../Backend/Rest/Connector';
import {Factory as RequestSimpleFactory} from '../../Backend/Rest/Request/Simple/Factory';
import {BaseAbstract} from './BaseAbstract';
import {Observable} from 'rxjs/Observable';

export class AvailableEmail extends BaseAbstract {

    private url: string = null;

    private method: string = null;

    private keyError: string = null;

    private requestSimpleFactory: RequestSimpleFactory = null;

    private restConnector: RestConnector = null;

    // ########################################

    constructor(
        url: string,
        method: string,
        keyError: string,
        requestSimpleFactory: RequestSimpleFactory,
        restConnector: RestConnector
    ) {
        super();

        this.url = url;
        this.method = method;
        this.keyError = keyError;
        this.requestSimpleFactory = requestSimpleFactory;
        this.restConnector = restConnector;
    }

    // ########################################

    protected validate(): (control: FormControl) => Observable<ValidationErrors | null>  {
        return (control: FormControl) => {

            return timer(1000).pipe(
                switchMap(() => {
                    const request = this.requestSimpleFactory.create(this.url, this.method, '');

                    return this.restConnector.process(request)
                        .pipe(
                            map((response: SuccessResponse) => {
                                const responseData = response.getBody().data;

                                const available = responseData.includes(control.value);

                                if (available === true) {

                                    return {
                                        [this.keyError]: true
                                    };
                                } else {

                                    return null;
                                }
                            })
                        );
                })
            );
        };
    }

    // ########################################
}
